var SupportFinePrintPresenterPresentation, SupportUtilsHelper;

SupportUtilsHelper = require('../helpers/utils');

SupportFinePrintPresenterPresentation = (function() {
  function SupportFinePrintPresenterPresentation() {}

  SupportFinePrintPresenterPresentation.prototype.present = function(order) {
    var text;
    return text = (function() {
      switch (order.DEAL_TYPE) {
        case 'GETAWAYS_MARKET_RATE':
          return this.marketRateFinePrintConstructor(order);
        default:
          return this.v1FinePrintConstructor(order);
      }
    }).call(this);
  };

  SupportFinePrintPresenterPresentation.prototype.v1FinePrintConstructor = function(order) {
    var ref;
    if (order == null) {
      return "";
    }
    return replaceNewLineWithBreak((ref = order.deal) != null ? ref.finePrint : void 0);
  };

  SupportFinePrintPresenterPresentation.prototype.marketRateFinePrintConstructor = function(order) {
    var cancellationPolicies, reservationSource;
    reservationSource = SupportUtilsHelper.getReservationSource(order);
    if (reservationSource == null) {
      return "";
    }
    cancellationPolicies = _.reduce(reservationSource.cancellationPolicies, (function(memo, policy) {
      return "" + memo + policy.descriptionHtml + " <br />";
    }), "");
    return reservationSource.crsPolicyHtml + " <br />Cancellation Policies <br /><br /> " + cancellationPolicies;
  };

  return SupportFinePrintPresenterPresentation;

})();

module.exports = SupportFinePrintPresenterPresentation;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvcHJlc2VudGVycy9maW5lX3ByaW50X3ByZXNlbnRlci5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9ybXVydWdhbi9uYXBpc3RyYW5vL2J1aWxkLzE1MDE3ODIwMTYzMDYtNTk0MzUvcHJvZHVjdGlvbi0yMDE3LjA4LjAzXzE3LjM2L3N1cHBvcnRfYXBwL21vZHVsZXMvc3VwcG9ydC9mcm9udGVuZC9wcmVzZW50ZXJzL2ZpbmVfcHJpbnRfcHJlc2VudGVyLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQSxJQUFBOztBQUFBLGtCQUFBLEdBQXFCLE9BQUEsQ0FBUSxrQkFBUjs7QUFFZjs7O2tEQUNKLE9BQUEsR0FBUyxTQUFDLEtBQUQ7QUFDUCxRQUFBO1dBQUEsSUFBQTtBQUFPLGNBQU8sS0FBSyxDQUFDLFNBQWI7QUFBQSxhQUNBLHNCQURBO2lCQUM0QixJQUFDLENBQUEsOEJBQUQsQ0FBZ0MsS0FBaEM7QUFENUI7aUJBRUEsSUFBQyxDQUFBLHNCQUFELENBQXdCLEtBQXhCO0FBRkE7O0VBREE7O2tEQUtULHNCQUFBLEdBQXdCLFNBQUMsS0FBRDtBQUN0QixRQUFBO0lBQUEsSUFBaUIsYUFBakI7QUFBQSxhQUFPLEdBQVA7O1dBQ0EsdUJBQUEsaUNBQWtDLENBQUUsa0JBQXBDO0VBRnNCOztrREFJeEIsOEJBQUEsR0FBZ0MsU0FBQyxLQUFEO0FBQzlCLFFBQUE7SUFBQSxpQkFBQSxHQUFvQixrQkFBa0IsQ0FBQyxvQkFBbkIsQ0FBd0MsS0FBeEM7SUFDcEIsSUFBaUIseUJBQWpCO0FBQUEsYUFBTyxHQUFQOztJQUNBLG9CQUFBLEdBQXVCLENBQUMsQ0FBQyxNQUFGLENBQVMsaUJBQWlCLENBQUMsb0JBQTNCLEVBQWlELENBQUUsU0FBQyxJQUFELEVBQU8sTUFBUDthQUFrQixFQUFBLEdBQUcsSUFBSCxHQUFVLE1BQU0sQ0FBQyxlQUFqQixHQUFpQztJQUFuRCxDQUFGLENBQWpELEVBQWtILEVBQWxIO1dBQ3BCLGlCQUFpQixDQUFDLGFBQW5CLEdBQWlDLDRDQUFqQyxHQUE2RTtFQUpqRDs7Ozs7O0FBTWxDLE1BQU0sQ0FBQyxPQUFQLEdBQWlCIn0=
